// extracted by mini-css-extract-plugin
export default {"tabs":"P3-z","tablist":"Q3-z","tablistItem":"R3-z"};